import { adapter, initialState, State } from './api-keys.state'
import * as R from 'ramda'
import { addApiKey, deleteApiKeyComplete, loadApiKeysComplete } from '../api-keys/api-keys.actions'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(loadApiKeysComplete, (state, { keys }) => adapter.addAll(keys, R.merge(state, { isLoaded: true }))),
  on(addApiKey, (state, { key }) => adapter.addOne(key, state)),
  on(deleteApiKeyComplete, (state, { id }) => adapter.removeOne(id, state))
)

export function apiKeysReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
